module.exports = __webpack_public_path__ + "img/edit-icon.72e870b1.svg";